import type { TableRowData } from '../components/Table/types/data'
import { getInitialTableData } from '../components/Table/utils/data'
import { useCreateElemental } from './mutations/elemetal/useCreateElemental'

export function useCreateTable() {
  const { mutate, isPending } = useCreateElemental()
  const user = useUser()
  const router = useRouter()

  const createTable = async () => {
    if (!user.value)
      return router.push(useGetLoginURL())

    const table = getInitialTableData()
    const title = `Table ${formatDateCST(new Date())}`
    mutate(
      {
        elemental: {
          title,
          rows: table.rowData.map((row: TableRowData) => {
            return {
              ...row,
              metadata: JSON.stringify(row.metadata ?? {}), // Convert metadata to string for backend
            }
          }),
          isPrivate: true,
          columns: table.columns,
          data: table,
          isPremium: false,
          description: '',
          attachments: [],
          images: {
            cover: [],
            output: [],
          },
          url: '',
        },
        elementalType: ElementalTypeEnum.Table,
      },
      {
        onSuccess: (elemental) => {
          if (elemental?.id)
            router.push(`/table/${elemental?.url}/edit`)
        },
      },
    )
  }

  return {
    createTable,
    isPending,
  }
}
